module.exports = __webpack_public_path__ + "img/22.23c3d75f.jpg";